import { HttpInterceptorFn, HttpEvent, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { catchError, throwError, tap } from 'rxjs';
import Swal from 'sweetalert2';

let isShowingSessionExpired = false;

export const ValidTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(MicrosoftAuthService);

  return next(req).pipe(
    tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        const newSessionToken = event.headers.get('x-new-session-token');
        if (newSessionToken) {
          authService.setSessionToken(newSessionToken);
        }
      }
    }),
    catchError((error) => {
      if (error.status === 401) {
        showCautionSesion(authService);
      }
      return throwError(() => error);
    })
  );
};

function showCautionSesion(authService: MicrosoftAuthService) {
  if (isShowingSessionExpired) return;
  isShowingSessionExpired = true;

  authService.clearSesion();

  Swal.fire({
    title: 'Sesión Expirada',
    text: 'Su sesión ha caducado. Redirigiendo al inicio de sesión...',
    icon: 'warning',
    confirmButtonText: 'OK',
    timer: 3000,
    timerProgressBar: true,
    allowOutsideClick: false
  }).then(() => {
    window.location.href = '/'
  })
}